import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Index from "./components/dashboard/Index";
import Home from "./components/Home";
import About from "./components/About";
import Navbar from "./components/Navbar";

import Profile from "./components/auth/Profile";
import ProtectedRoute from "./components/auth/ProtectedRoutes";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import SubjectTree from "./components/subject/SubjectTree";
import DesignLabPage from "./features/design-lab/DesignLabPage";
import InfiniteGistSheetPage from "./features/infinite-gist-sheet/InfiniteGistSheetPage";
import SubjectsLabPage from "./features/subjects-lab/SubjectsLabPage";
import CommentExplorerLabPage from "./features/comment-explorer-lab/CommentExplorerLabPage";
import NavigatorPage from "./features/navigator/NavigatorPage";
import SubjectItemsPage from "./features/subject-items/SubjectItemsPage";
import SubjectSinglePage from "./features/subject-single/SubjectSinglePage";
import GistsCanonicalPage from "./features/canonical-gists/GistsCanonicalPage";
import PublicSubjectPage from "./features/public-pages/PublicSubjectPage";
import PublicGistPage from "./features/public-pages/PublicGistPage";
import DirectPublicGistPage from "./features/public-pages/DirectPublicGistPage";
import PublicUserPage from "./features/public-pages/PublicUserPage";
import DraftsCenterPage from "./features/drafts/DraftsCenterPage";
import BulkAuthoringPage from "./features/bulk-authoring/BulkAuthoringPage";
import DraftTreeWorkspacePage from "./features/draft-tree/DraftTreeWorkspacePage";
import ImportReviewWorkspacePage from "./features/import-review/ImportReviewWorkspacePage";

const App: React.FC = () => {
  return (
    <Router>
      <div className="site-navbar-wrap">
        <Navbar />
      </div>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredUserType="admin">
              <Index />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<SubjectTree />} />
        <Route path="/design-lab" element={<DesignLabPage />} />
        <Route path="/gist-lab" element={<InfiniteGistSheetPage />} />
        <Route path="/gist-sheet-lab" element={<InfiniteGistSheetPage />} />
        <Route path="/subjects-lab" element={<SubjectsLabPage />} />
        <Route path="/comment-lab" element={<CommentExplorerLabPage />} />
        <Route path="/comment-explorer-lab" element={<CommentExplorerLabPage />} />
        <Route path="/navigator" element={<NavigatorPage />} />
        <Route path="/subject-items" element={<SubjectItemsPage />} />
        <Route path="/subject-single" element={<SubjectSinglePage />} />
        <Route
          path="/workspace/s/:subjectPublicId"
          element={
            <ProtectedRoute>
              <SubjectSinglePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace/g/:gistPublicId"
          element={
            <ProtectedRoute>
              <SubjectSinglePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace/drafts"
          element={
            <ProtectedRoute>
              <DraftsCenterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace/bulk-authoring"
          element={
            <ProtectedRoute requiredUserType="admin">
              <BulkAuthoringPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace/draft-tree"
          element={
            <ProtectedRoute>
              <DraftTreeWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace/import-review/:subjectPublicId"
          element={
            <ProtectedRoute>
              <ImportReviewWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route path="/gists" element={<GistsCanonicalPage />} />
        <Route path="/g/:gistPublicId" element={<DirectPublicGistPage />} />
        <Route path="/s/:subjectSlug" element={<PublicSubjectPage />} />
        <Route path="/s/:subjectSlug/:gistSlugWithId" element={<PublicGistPage />} />
        {/* React Router does not reliably treat /@:handle as a dynamic route,
            so /@test-admin is also handled by this single-segment fallback. */}
        <Route path="/@:handle" element={<PublicUserPage />} />
        <Route path="/:handleWithAt" element={<PublicUserPage />} />
        <Route path="/:type/:title/:id" element={<Home />} />

        <Route path="/login" element={<Login />} />
        <Route path="/login/:token" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
